import { render, staticRenderFns } from "./inviteFriends.vue?vue&type=template&id=6b3b8eda&scoped=true"
import script from "./inviteFriends.vue?vue&type=script&lang=js"
export * from "./inviteFriends.vue?vue&type=script&lang=js"
import style0 from "./inviteFriends.vue?vue&type=style&index=0&id=6b3b8eda&prod&lang=css"
import style1 from "./inviteFriends.vue?vue&type=style&index=1&id=6b3b8eda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b8eda",
  null
  
)

export default component.exports